import React from 'react'
import { FormControlLabel, Checkbox, Typography, Popover } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { showFlashMessage, showFlashMessageOnUnexpectedError, updateUserSettings, cancelSubscription, userInfo, updateUser } from 'actions'
import isempty from 'lodash.isempty'
import starIcon from 'images/svg/star-icon.svg'
import Button from 'components/ButtonMaterial'
import { MESSAGE, SETTINGS } from '../../../constants'
import { isUserPremium } from '../../../utils'
import CircularProgress from '@material-ui/core/CircularProgress'
import CheckoutForm from 'features/payment/components/CheckoutForm'

const styles = theme => ({
  details: {
    marginTop: '5%',
  },
  settingsOption: {
    marginTop: '3%',
  },
  notifyHeader: {
    fontSize: '14px',
    fontWeight: '500',
  },
  notifyOption: {
    fontSize: '15px',
    lineHeight: '24px',
  },
  root: {
    color: '#9e9e9e',
    '&$checked': {
      color: '#00bcb5',
    },
  },
  buttonProgress: {
    color: '#fff',
  },
  checked: {},
  filterChecklabel: {
    marginLeft: '0',
    marginRight: '0',
    paddingTop: '2%',
    [theme.breakpoints.down('sm')]: { paddingTop: '4%' },
    width: '23%',
    '& span': {
      '&:first-child': {
        width: '30%',
        height: '30%',
      },
      '&:last-child': {
        fontSize: '13px',
        paddingLeft: '8%',
        paddingTop: '2%',
        color: '#5b5d62',
        width: '65%',
        lineHeight: '17px',
      },
    },
  },
  CardChecklabel: {
    marginLeft: '0',
    marginRight: '0',
    width: 'auto',
    '& span': {
      '&:first-child': {
        padding: '0 4px 0 0',
      },
      '&:last-child': {
        fontSize: '13px',
        color: '#5b5d62',
        lineHeight: '17px',
      },
    },
  },
  updateBtn: {
    width: '40%',
  },
  premiumCardcontainer: {
    width: '100%',
    padding: '20px 32px',
    borderRadius: '4px',
    boxShadow: '0 2px 16px -8px rgba(0, 0, 0, 0.09)',
    border: 'solid 1px #ededed',
    backgroundColor: '#fff',
    margin: '30px 0 0',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 16px',
    },
  },
  premiumCardbox: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  premiumCardheading: {
    fontSize: '16px',
    lineHeight: '1.5',
    fontWeight: '500',
    color: '#ffd200',
  },
  premiumstarIcon: {
    width: '24px',
    margin: '0 12px 0 8px',
  },
  premiumCarddays: {
    fontSize: '13px',
    color: '#5b5d62',
  },
  paymentMethodbox: {
    margin: '25px 0 0',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  paymentMethodheading: {
    fontSize: '16px',
    color: '#333645',
  },
  paymentChangebutton: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#00bcb5',
    opacity: '0.8',
    textDecoration: 'none',
    width: 'auto',
    background: 'transparent',
    textTransform: 'inherit',
    padding: '0',
    height: 'auto',
    lineHeight: 'normal',
    margin: '2px 0 0',
    '&:hover': {
      background: 'transparent',
      textTransform: 'inherit',
      color: '#00bcb5',
    },
  },
  paymentCardbox: {
    fontSize: '14px',
    color: '#838383',
    margin: '16px 0 0',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  paymentCardtype: {
    margin: '0 20px 0 0',
    textTransform: 'uppercase',
  },
  paymentCardnumber: {
    fontWeight: '500',
  },
  premiumrenewalBox: {
    margin: '24px 0 0',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  premiumCancelbutton: {
    fontSize: '12px',
    opacity: '0.8',
    fontWeight: '500',
    color: '#727272',
    margin: '1px 0 0',
    width: 'auto',
    background: 'transparent',
    textTransform: 'inherit',
    padding: '0',
    height: 'auto',
    lineHeight: '100%',
    '&:hover': {
      background: 'transparent',
      textTransform: 'inherit',
      color: '#727272',
    },
  },
  premiumButton: {
    width: '100%',
    fontSize: '15px',
    height: '44px',
    margin: '25px 0 0',
    borderRadius: '4px',
    border: '0',
    fontWeight: '500',
    textTransform: 'uppercase',
    outline: '0',
    cursor: 'pointer',
    backgroundColor: '#00bcb5',
    color: 'rgba(255, 255, 255, 0.8)',
  },
  cancelPopover: {
    width: '300px',
    boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.09)',
    border: 'solid 1px #ececec',
    backgroundColor: '#fff',
    padding: '23px 28px',
    marginLeft: 'auto',
  },
  cancelSubsHeading: {
    fontSize: '17px',
    color: '#2d3447',
  },
  cancelsubsAction: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '23px 0 0',
  },
  subsnoBtn: {
    fontSize: '14px',
    color: '#838383',
    width: 'auto',
    background: 'transparent',
    textTransform: 'inherit',
    padding: '0',
    height: 'auto',
    lineHeight: '100%',
    '&:hover': {
      background: 'transparent',
      textTransform: 'inherit',
      color: '#838383',
    },
  },
  subscancelBtn: {
    padding: '3px 18px',
    height: '28px',
    width: 'auto',
    flex: 'none',
    borderRadius: '4px',
    backgroundColor: '#ef4135',
    fontSize: '13px',
    border: '0',
    cursor: 'pointer',
    outline: '0',
    textTransform: 'uppercase',
    fontWeight: '500',
    color: 'rgba(255, 255, 255, 0.8)',
    minWidth: '185px',
    '&:hover': {
      backgroundColor: '#ef4135',
      color: 'rgba(255, 255, 255, 0.8)',
    },
  },
})

class InvestorSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      emailNotifications: this.props.user.emailNotifications,
      autoRenew: true,
      anchorEl: null,
      loading: false,
      showDetail: false,
    }
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked })
  }

  toggleDetail() {
    const { showDetail } = this.state
    this.setState({
      showDetail: !showDetail,
    })
  }

  async updateSettings() {
    try {
      const dataToBeUpdated = { emailNotifications: this.state.emailNotifications }
      const response = await this.props.updateUserSettings(dataToBeUpdated, this.props.user.token)

      if (isempty(response.errors)) {
        this.props.handleClose()
        this.props.showFlashMessage(null, `Your notifications settings have been updated successfully!`)
      } else {
        this.props.showFlashMessage(true, `${Object.entries(response.errors).join(';')}`)
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error, MESSAGE.CONTACT_ADMIN)
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ anchorEl: null })
  }

  loadingState = () => {
    this.setState(prevState => ({
      loading: !prevState.loading,
    }))
  }

  async cancelSubscription() {
    this.loadingState()
    try {
      const response = await this.props.cancelSubscription(this.props.user.token)
      this.loadingState()
      if (isempty(response.errors)) {
        this.props.userInfo(this.props.user.token)
        this.props.handleClose()
        this.props.showFlashMessage(null, `Your subscription has been cancelled successfully!`)
      } else {
        this.props.showFlashMessage(true, response.errors[0])
      }
    } catch (error) {
      this.loadingState()
      this.props.showFlashMessageOnUnexpectedError(error, MESSAGE.CONTACT_ADMIN)
    }
  }

  async updateCard(stripeToken) {
    try {
      const response = await this.props.updateUser({ stripeToken: stripeToken }, this.props.user.token)
      if (isempty(response.errors)) {
        this.props.showFlashMessage(null, `Your card has been updated successfully!`)
        this.props.userInfo(this.props.user.token)
      } else {
        this.props.showFlashMessage(true, response.errors[0])
      }
    } catch (error) {
      this.props.showFlashMessageOnUnexpectedError(error)
    }
  }

  render() {
    const { classes, user } = this.props
    const { anchorEl, loading, showDetail } = this.state
    const open = Boolean(anchorEl)
    return (
      <div>
        <div className={classes.details}>
          <div>
            <Typography className={classes.notifyHeader}>NOTIFY ME</Typography>
          </div>
          <div className={classes.settingsOption}>
            <Typography color="textSecondary" className={classes.notifyOption}>
              When a property is available on my saved search
            </Typography>
            <FormControlLabel
              className={classes.filterChecklabel}
              key="email"
              control={
                <Checkbox
                  value="emailNotifications"
                  onChange={this.handleChange('emailNotifications')}
                  checked={this.state.emailNotifications}
                  classes={{
                    root: classes.root,
                    checked: classes.checked,
                  }}
                />
              }
              label="Email"
            />
          </div>
          <div align="right">
            <Button className={classes.updateBtn} onClick={() => this.updateSettings()}>
              Update
            </Button>
          </div>
          <div className={classes.premiumCardcontainer} hidden={!isUserPremium(user)}>
            <div className={classes.premiumCardbox}>
              <div className={classes.premiumCardheading}>Premium Member</div>
              <span className={classes.premiumstarIcon}>
                <img alt="star" src={starIcon} />
              </span>
            </div>
            <div className={classes.paymentMethodbox}>
              <div className={classes.paymentMethodheading}>Payment method</div>
              <Button className={classes.paymentChangebutton} onClick={() => this.toggleDetail()}>
                Change
              </Button>
            </div>
            <div className={classes.paymentCardbox}>
              <div className={classes.paymentCardtype}>{user.stripeBrand}</div>
              <div className={classes.paymentCardnumber}>XXXX XXXX XXXX {user.stripeLast4}</div>
            </div>
            <div className={classes.premiumrenewalBox}>
              <Button className={classes.premiumCancelbutton} aria-describedby={open ? 'mouse-over-popover' : undefined} onClick={this.handleClick}>
                Cancel Premium
              </Button>
            </div>
          </div>
        </div>
        <Popover
          id="mouse-over-popover"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}>
          <div className={classes.cancelPopover}>
            <div className={classes.cancelSubsHeading}>I don’t want to be a Premium Member anymore</div>
            <div className={classes.cancelsubsAction}>
              <Button className={classes.subsnoBtn} onClick={() => this.handleClose()}>
                No
              </Button>
              <button className={classes.subscancelBtn} onClick={() => this.cancelSubscription()} disabled={loading}>
                {loading ? <CircularProgress size={16} className={classes.buttonProgress} /> : 'Cancel Subscription'}
              </button>
            </div>
          </div>
        </Popover>
        <CheckoutForm open={showDetail} onClose={() => this.toggleDetail()} from={SETTINGS} onTokenCreate={token => this.updateCard(token)} />
      </div>
    )
  }
}

InvestorSettings.propTypes = {
  user: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showFlashMessage,
      showFlashMessageOnUnexpectedError,
      updateUserSettings,
      cancelSubscription,
      userInfo,
      updateUser,
    },
    dispatch
  )
}

export default withStyles(styles)(
  connect(
    null,
    mapDispatchToProps
  )(InvestorSettings)
)



// WEBPACK FOOTER //
// ./src/features/investorDashboard/components/InvestorSettings.js